import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../../controllers';
import { BooleanField, EnumField, LinkField, NumberField, TextField } from '../../../../fields';
import { BooleanInput, EnumInput, NumberInput, ReferenceInput, TextInput } from '../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextField
          source="name"
        />
        <NumberInput
          source="position"
        />
        <EnumInput
          source="class_name"
          versionedAttribute
        />
        <TextInput
          source="description"
        />
        <TextInput
          source="example_value"
        />
        <TextInput
          source="default_value"
        />
        <NumberInput
          source="validate_greater_than"
        />
        <NumberInput
          source="validate_greater_than_or_equal"
        />
        <NumberInput
          source="validate_less_than"
        />
        <NumberInput
          source="validate_less_than_or_equal"
        />
        <BooleanInput
          source="validate_whole_number"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ library_engine_event_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="name"
        />
        <NumberInput
          source="position"
        />
        <EnumInput
          source="class_name"
          versionedAttribute
        />
        <ReferenceInput
          source="library_widget_id"
        />
        <TextInput
          source="description"
        />
        <TextInput
          source="example_value"
        />
        <TextInput
          source="default_value"
        />
        <NumberInput
          source="validate_greater_than"
        />
        <NumberInput
          source="validate_greater_than_or_equal"
        />
        <NumberInput
          source="validate_less_than"
        />
        <NumberInput
          source="validate_less_than_or_equal"
        />
        <BooleanInput
          source="validate_whole_number"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="position"
        />
        <TextField
          source="name"
        />
        <EnumField
          source="class_name"
          versionedAttribute
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="name"
        />
        <TextField
          source="position"
        />
        <EnumField
          source="class_name"
        />
        <LinkField
          source="library_widget_id"
          allowEmpty
        />
        <TextField
          source="description"
        />
        <TextField
          source="example_value"
        />
        <TextField
          source="default_value"
        />
        <NumberField
          source="validate_greater_than"
        />
        <NumberField
          source="validate_greater_than_or_equal"
        />
        <NumberField
          source="validate_less_than"
        />
        <NumberField
          source="validate_less_than_or_equal"
        />
        <BooleanField
          source="validate_whole_number"
        />
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
